import {utility} from '../utilites/index';
import ValidationError from '../utilites/networkErrors/ValidationError';
import {INetworkLayer} from "../utilites/index";

export abstract class ActiveRecord {
  public static path = '/api';

  static listAction(query = {}, perPage = 50, page = 0) {
    query = Object.assign({}, query, {
      page,
      perPage
    });

    return utility.networkLayer.getJson(this.path,
      {
        ...query,
        _t: Date.now()
      })
      .then(data => this.mapRecords(data));
  }

  /**
   *
   * @param [Object] data
   * @return [ActiveRecord]
   */
  static mapRecords(data) {
    // /*eslint  no-console: 0*/
    // console.error('Need implement method in your class');
    return data;
  }

  constructor(data: any = {}) {
    this._extendData(data);
    this._networkLayer = utility.networkLayer;
  }

  protected _networkLayer: INetworkLayer;

  protected _id: string;
  public get id(): string {
    return this._id;
  }

  public set id(id: string) {
    this._id = id;
  }

  isNew() {
    return this._id === undefined;
  }

  fetch() {
    try {
    return this._networkLayer.getJson(this._prepareUrl(this.id), {
      _t: Date.now()
    })
      .then((data) => this.loadFromData(data));
    }

    catch (e) {
      return this.checkValidateResponse(e);
    }
  }

  async save(data): Promise<ActiveRecord> {
    try {
      let dataForSave = this.prepareForSave(data);
      let res = this.isNew()
        ? await this._createRecord(dataForSave)
        : await this._updateRecord(dataForSave);

      this._afterSave(res);

      return this;
    }

    catch (e) {
      await this.checkValidateResponse(e);
    }

  }

  protected async _createRecord(dataForSave) {
    return await this._networkLayer.postJson(this._prepareUrl(), dataForSave)
  }

  protected async _updateRecord(dataForSave) {
    return await this._networkLayer.putJson(this._prepareUrl(this._id), dataForSave);
  }

  async checkValidateResponse(e) {
    if (e instanceof ValidationError) {
      let errors = await e.getTranslatedMessages();
      throw errors;
    } else {
      throw e;
    }
  }

  _afterSave(data) {
    let preparedData = this._parseData(data);
    this._extendData(preparedData);
    return this;
  }

  remove() {
    let promise = new Promise<void>((res, req) =>{
      if (this._isAbleToDelete()) {
        res();
      } else{
        req();
      }
    });

    return promise.then(() => this._networkLayer.remove(this._prepareUrl(this.id)));
  }

  loadFromData(data) {
    return this._extendData(this._parseData(data));
  }

  _parseData(data) {
    return data;
  }

  _isAbleToDelete() {
    return true;
  }

  protected _prepareUrl(id: string = ''): string {
    return this.constructor['path'] + (!!id ? '/' + id : '');
  }

  _extendData(data): any {
    Object.assign(this, data);
    return this;
  }

  prepareForSave(data) {
    return Object.assign({}, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/ActiveRecord.ts